import { render, staticRenderFns } from "./AccessPermissionsDetail.vue?vue&type=template&id=550f0031&scoped=true"
import script from "./AccessPermissionsDetail.vue?vue&type=script&lang=js"
export * from "./AccessPermissionsDetail.vue?vue&type=script&lang=js"
import style0 from "./AccessPermissionsDetail.vue?vue&type=style&index=0&id=550f0031&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550f0031",
  null
  
)

export default component.exports